// A very simple file with no circular dependencies for HMR.

export const primaryButtonClass =
    "rounded-lg bg-purple-100 px-2.5 py-0.75 text-[13px] font-medium text-gray-900 ring-1 ring-inset ring-purple-100 hover:bg-gray-50";
export const secondaryButtonClass =
    "rounded-lg bg-gray-100 px-2.5 py-0.75 text-[13px] font-medium text-gray-900 ring-1 ring-inset ring-gray-100 hover:bg-gray-50";

export const abortButtonClass =
    "rounded-lg bg-rose-50 px-2.5 py-0.75 text-[13px] font-medium text-gray-900 ring-1 ring-inset ring-gray-100 hover:bg-gray-50";

export const dayFormStyles = {
    row: "flex text-center",
    label: "flex-1 whitespace-nowrap border-0 min-w-[31%] text-right font-medium self-center mr-[3px]",
    firstHeader: "flex-1 min-w-[31%]",
    header: "flex-1 font-medium min-w-[23%] text-center",
    total: "flex-1 min-w-[23%]",
    target: "day-target flex-1 min-w-[23%]",
    remaining: "flex-1 min-w-[23%]",
    optionalSection: "",
    optionalRow: "flex text-right",
    optionalLabel:
        "flex-1 whitespace-nowrap min-w-[31%] font-medium text-xs overflow-hidden text-ellipsis",
    optionalMacro: "flex-1 whitespace-nowrap min-w-[23%] text-center text-xs",
} as const;

// The warm-to-lilac page gradient (the walking club's), and its top stop
// at the header's translucency.
export const JOY_GRADIENT =
    "linear-gradient(175deg, oklch(0.96 0.024 45), oklch(0.958 0.020 60) 22%, oklch(0.958 0.020 320) 48%, oklch(0.94 0.03 278))";
export const JOY_GRADIENT_TOP = "oklch(0.96 0.024 45)";

// The 31 series ink: everything on the gradient reads in this cool near-black,
// with the muted and accent tones beside it.
export const INK = "text-[oklch(0.24_0.02_280)] tracking-[-0.01em]";
export const MUTED = "text-[oklch(0.5_0.03_280)]";
export const ACCENT = "text-[oklch(0.45_0.19_278)]";
export const ACCENT_BG = "bg-[oklch(0.51_0.21_278)]";
export const HAIRLINE = "border-[oklch(0.35_0.04_280_/_0.08)]";
export const EYEBROW =
    "text-[11.5px] font-normal tracking-[0.06em] text-[oklch(0.4_0.03_280)] uppercase";
export const GLASS_INSET = "shadow-[inset_0_0_0_0.5px_rgba(255,255,255,0.9)]";
export const BUBBLE =
    "rounded-[11px] px-3.5 py-2.5 text-[13px] leading-none whitespace-nowrap";
export const BUBBLE_IDLE = "bg-white font-normal text-[oklch(0.35_0.03_280)]";
export const BUBBLE_ON = "bg-[oklch(0.51_0.21_278)] font-medium text-white";
export const BUBBLE_DASHED =
    "font-normal text-[oklch(0.45_0.10_278)] shadow-[inset_0_0_0_1.5px_oklch(0.51_0.21_278_/_0.3)]";
export const BUBBLE_GHOST =
    "font-normal text-[oklch(0.5_0.03_280)] shadow-[inset_0_0_0_1.5px_oklch(0.5_0.03_280_/_0.25)]";
export const FIELD = "rounded-[11px] bg-white text-[oklch(0.24_0.02_280)]";

export const BUTTON_CLASS =
    "text-white rounded-md text-xl/6 font-inter font-light px-6 py-4 bg-[#7D50FF] hover:bg-[#7D50FF]/95 disabled:opacity-50";

export const BUTTON_CLASS_SMALL =
    "text-white rounded-md text-sm/6 font-inter font-medium px-4 py-1.5 bg-[#7D50FF] hover:bg-[#7D50FF]/95 disabled:opacity-50";

export const ratingRequestClass =
    "rating-request animate-[flip-in-x_1s] w-full my-2.5 mx-auto bg-[#d9edf7] text-[#1a4b6b]";

export const migrateClass =
    "border-b border-[#D8D8D8] p-2.5 flex flex-col gap-1.5 items-center";
